import { render, staticRenderFns } from "./EquipDetails.vue?vue&type=template&id=91b738f6"
import script from "./EquipDetails.vue?vue&type=script&lang=js"
export * from "./EquipDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EquipDetails.vue?vue&type=custom&index=0&blockType=stype&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports